module.exports = __webpack_public_path__ + "static/media/pencil.8809d3cf.svg";